<template>
  <span :class="'red--text tex--darken-3 ' + cmp_class" v-html="text"></span>
</template>

<script>
export default {
  name: "RedText",
  props: {
    text: {
      type: String,
      default: "",
    },
    cmp_class: {
      type: String,
      default: "",
    },
  },
};
</script>